import { PromoBrands } from '~/services/PromoService';

const promoBrandValues = new Set<string>([
  'luxuryescapes',
  'cudo',
  'deals',
  'treatme',
  'scooponexperience',
  'scoopontravel',
  'cudotravel',
  'dealstravel',
  'treatmetravel',
  'kogantravel',
  'lebusinesstraveller',
  'zoomzoom',
  'leagenthub',
  'leagenthub_cvfr',
]);

export function isPromoBrand(brand: App.Brands): brand is Extract<App.Brands, PromoBrands> {
  return promoBrandValues.has(brand);
}
